import {ProductsList} from '../../components/submit-forms'

const init = () => {
  ProductsList()
}

export default init
